import * as z from 'zod';

export const refundRequestSchema = z.object({
  bookingId: z.string().uuid({ message: "Invalid booking ID" }),
  exitDate: z.string().min(1, { message: "Exit date is required" }),
  remarks: z.string().optional(),
  requestedAmount: z
    .number({ invalid_type_error: "Amount must be a number" })
    .min(1, { message: "Requested amount must be at least 1 AED" }),
  clientIds: z
    .array(z.string().uuid({ message: "Invalid client ID" }))
    .nonempty({ message: "Select at least one client" })
    .optional(), // make optional
});


export type RefundRequestFormData = z.infer<typeof refundRequestSchema>;
